import { render, staticRenderFns } from "./LeaguesResult.vue?vue&type=template&id=a153b960&"
import script from "./LeaguesResult.vue?vue&type=script&lang=js&"
export * from "./LeaguesResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports